import { GithubOutlined } from '@ant-design/icons';
import { DefaultFooter } from '@ant-design/pro-components';
import React from 'react';

const Footer: React.FC = () => {
  return (
    <DefaultFooter
      style={{
        background: 'none',
      }}
      copyright="Powered by HX Sign"
      links={[
        {
          key: 'company',
          title: (
            <span
              style={{ cursor: 'default' }}
              onClick={(e) => e.preventDefault()}
            >
              天津市和信公证处
            </span>
          ),
          href: '',
        },
        {
          key: 'phone',
          title: (
            <span
              style={{ cursor: 'default' }}
              onClick={(e) => e.preventDefault()}
            >
              电话: 022-88216470
            </span>
          ),
          href: '',
        },
        {
          key: '12010302002473',
          title: '津公网安备12010302002473号',
          href: 'https://beian.mps.gov.cn/#/query/webSearch',
          blankTarget: true,
        },
                {
          key: '20002163',
          title: '津ICP备20002163号-2',
          href: 'https://beian.miit.gov.cn/',
          blankTarget: true,
        },
      ]}
    />
  );
};

export default Footer;
